import { useThemeStore } from "@stores/theme.store";
import { Button, Form, Input, Select } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
const { Option } = Select;
const { TextArea } = Input;
export const SuggestionFormPage = () => {
  const navigate = useNavigate();
  const { setHeader } = useThemeStore((state) => state);

  useEffect(() => {
    setHeader({
      buttonBack: false,
      filter: false,
      title: "Kritik dan Saran",
    });
  }, [setHeader]);

  return (
    <div className="tw-px-4 tw-pb-20">
      <div className="tw-mb-6 tw-bg-other-100 tw-rounded-md card-body">
        <div className="tw-mb-4 tw-text-xl tw-text-center">
          Assalaamu'alaikum <br />
          Wa Rahmatullahi Wa Barakaatuh
        </div>
        <div className="tw-text-sm tw-text-center tw-text-other-600">
          Media ini dibuat untuk menampung segala saran dan kritik Anda,
          manfaatkan kesempatan ini untuk kemajuan BeQi Sragen.
        </div>
      </div>

      <Form className="" autoComplete="off">
        <Form.Item label="Nama" name="namasiswa" className="tw-mb-4">
          <Input
            className="tw-border-other-0 hover:tw-border-primary-hg tw-shadow-none focus:tw-shadow-none tw-text-base"
            placeholder="Nama"
            disabled={true}
            // {...register("username")}
          />
        </Form.Item>

        <Form.Item label="No. Telepon" name="nohp" className="tw-mb-4">
          <Input
            className="tw-border-other-0 hover:tw-border-primary-hg tw-shadow-none focus:tw-shadow-none tw-text-base"
            placeholder="No. Telepon"
            disabled={true}
            // {...register("username")}
          />
        </Form.Item>

        <Form.Item
          label="Email"
          name="email"
          className="tw-mb-4"
          rules={[{ type: "email", message: "Email harus sesuai" }]}
        >
          <Input
            className="tw-border-other-0 hover:tw-border-primary-hg tw-shadow-none focus:tw-shadow-none tw-text-base"
            placeholder="Email"
            // {...register("username")}
          />
        </Form.Item>

        <Form.Item
          label="Lembaga yang dituju"
          name="lembaga"
          className="tw-mb-4"
        >
          <Select
            className="tw-border-other-0 tw-text-base"
            placeholder="Pilih lembaga yang dituju"
            allowClear
          >
            <Option value="Lembaga 1">Lembaga 1</Option>
            <Option value="Lembaga 2">Lembaga 2</Option>
          </Select>
        </Form.Item>

        <Form.Item label="Topik" name="topik" className="tw-mb-4">
          <Input
            className="tw-border-other-0 hover:tw-border-primary-hg tw-shadow-none focus:tw-shadow-none tw-text-base"
            placeholder="Topik"
            // {...register("username")}
          />
        </Form.Item>

        <Form.Item label="Kritik dan Saran">
          <TextArea
            className="tw-border-other-0 hover:tw-border-primary-hg tw-shadow-none focus:tw-shadow-none tw-text-base"
            rows={4}
            placeholder="isi kritik dan saran"
          />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            className="tw-h-9 tw-w-full tw-mt-1 tw-mb-3 tw-bg-primary-hg focus:tw-shadow-none hover:tw-bg-other-100 hover:tw-text-primary-hg hover:tw-border-primary-hg"
          >
            Kirim
          </Button>
          <Button
            className="tw-h-9 tw-w-full tw-mt-1 focus:tw-shadow-none hover:tw-bg-primary-hg hover:tw-text-other-100 hover:tw-border-other-100 white-btn"
            htmlType="reset"
          >
            Batal
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};
